import { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { SetupPasswordPage } from './pages/SetupPasswordPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { HomePage } from './pages/HomePage';
import { DashboardOverviewPage } from './pages/DashboardOverviewPage';
import { LiteDashboardPage } from './pages/LiteDashboardPage';
import { StoreDashboardPage } from './pages/StoreDashboardPage';
import { PlTreePage } from './pages/PlTreePage';
import { TrendsPage } from './pages/TrendsPage';
import { StoreComparisonPage } from './pages/StoreComparisonPage';
import { UsersPage } from './pages/UsersPage';
import { EmployeesPage } from './pages/EmployeesPage';
import { EmployeeDetailPage } from './pages/EmployeeDetailPage';
import { ApprovalsPage } from './pages/ApprovalsPage';
import { ShiftRecordsPage } from './pages/ShiftRecordsPage';
import { ShiftUrgentPage } from './pages/ShiftUrgentPage';
import { ShiftPrintPage } from './pages/ShiftPrintPage';
import { ShiftReportDailyPage } from './pages/ShiftReportDailyPage';
import { ShiftReportEmployeesPage } from './pages/ShiftReportEmployeesPage';
import { ShiftReportCompliancePage } from './pages/ShiftReportCompliancePage';
import { RolesPage } from './pages/RolesPage';
import { AuditLogsPage } from './pages/AuditLogsPage';
import { AiMenuUsageRankingPage } from './pages/AiMenuUsageRankingPage';
import { DataBrowsePage } from './pages/DataBrowsePage';
import { LiteDataBrowsePage } from './pages/LiteDataBrowsePage';
import { ProfilePage } from './pages/ProfilePage';
import { MyIncomePage } from './pages/MyIncomePage';
// TD-28 §14 手順8 (D-9): 旧 /leave/me・/leave/manage は廃止し、申請は /requests へ、
// 残数・年5日・有休管理簿は /leave/records へ引き継いだ (§18-3)
import { LeaveRecordsPage } from './pages/leave/LeaveRecordsPage';
// v0.4 休暇管理 (TD-26) 段階⑥: 長期休業の管理
import { LeaveAbsencesPage } from './pages/LeaveAbsencesPage';
// v0.4 休暇管理 (TD-26) フロントエンド実装 (§6-1 L-2/L-5): バックエンドは段階④で完成していたが
// 付与を実行する画面と家族情報の画面が1行も実装されておらず、休暇を付与する手段がどこにも無かった
import { LeaveGrantsPage } from './pages/leave/LeaveGrantsPage';
import { MyFamilyPage } from './pages/MyFamilyPage';
import { MySkillsPage } from './pages/MySkillsPage';
// v0.5 人材育成ダッシュボード: 旧 TalentSkillsPage/TalentCertificationsPage/CompetencyMatrixPage/
// DevelopmentPlansPage をタブ統合 (docs/design/v05-talent-development-dashboard-detail.md §3-1)
import { TalentDashboardPage } from './pages/talent-dashboard/TalentDashboardPage';
import { PlacementConstraintsPage } from './pages/PlacementConstraintsPage';
import { TalentCoveragePage } from './pages/TalentCoveragePage';
// v0.5⑧ 経営会議PDCA (§7-7)
import { BoardMeetingsListPage } from './pages/board-meetings/BoardMeetingsListPage';
import { BoardMeetingDetailPage } from './pages/board-meetings/BoardMeetingDetailPage';
import { BoardInitiativesListPage } from './pages/board-initiatives/BoardInitiativesListPage';
import { BoardInitiativeDetailPage } from './pages/board-initiatives/BoardInitiativeDetailPage';
import { PlacementSimulationPage } from './pages/PlacementSimulationPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { NodesPage } from './pages/NodesPage';
import { ShiftPeriodsPage } from './pages/ShiftPeriodsPage';
import { ShiftBoardPage } from './pages/ShiftBoardPage';
import { ShiftCoordinationPage } from './pages/ShiftCoordinationPage';
import { ShiftMyPage } from './pages/ShiftMyPage';
import { ShiftPreferencesPage } from './pages/ShiftPreferencesPage';
import { ShiftStandingPatternsPage } from './pages/ShiftStandingPatternsPage';
import { SkillMastersPage } from './pages/SkillMastersPage';
import { StoreEventsPage } from './pages/StoreEventsPage';
import { AttendanceReasonCodesPage } from './pages/AttendanceReasonCodesPage';
import { EmployeeGradesPage } from './pages/EmployeeGradesPage';
import { WorkingTimeContractClassesPage } from './pages/WorkingTimeContractClassesPage';
import { MonthlyAttendanceEntryPage } from './pages/MonthlyAttendanceEntryPage';
import { WorkRecordApprovalsPage } from './pages/WorkRecordApprovalsPage';
import { AttendanceExportsPage } from './pages/AttendanceExportsPage';
import { AttendanceReviewPage } from './pages/AttendanceReviewPage';
import { PublishManagementPage } from './pages/PublishManagementPage';
import { PlatformAdminPage } from './pages/PlatformAdminPage';
import { SettingsLayout } from './pages/settings/SettingsLayout';
import { GeneralSettingsPage } from './pages/settings/GeneralSettingsPage';
import { HierarchyPage } from './pages/settings/HierarchyPage';
import { NodeTypesPage } from './pages/settings/NodeTypesPage';
import { ApprovalRuleBuilderPage } from './pages/settings/ApprovalRuleBuilderPage';
import { AggregationSettingsPage } from './pages/settings/AggregationSettingsPage';
import { VisitorCountSettingsPage } from './pages/settings/VisitorCountSettingsPage';
import { DataClosingDeadlinesSettingsPage } from './pages/settings/DataClosingDeadlinesSettingsPage';
import { ConsumptionTaxRatesSettingsPage } from './pages/settings/ConsumptionTaxRatesSettingsPage';
import { EmployeeCategoriesSettingsPage } from './pages/settings/EmployeeCategoriesSettingsPage';
import { EmploymentTypesSettingsPage } from './pages/settings/EmploymentTypesSettingsPage';
import { FeaturesSettingsPage } from './pages/settings/FeaturesSettingsPage';
import { PlaceholderSettingsPage } from './pages/settings/PlaceholderSettingsPage';
import { AiSettingsPage } from './pages/settings/AiSettingsPage';
import { AiInstructionsSettingsPage } from './pages/settings/AiInstructionsSettingsPage';
import { NotificationsSettingsPage } from './pages/settings/NotificationsSettingsPage';
import { ConditionsSettingsPage } from './pages/settings/ConditionsSettingsPage';
import { InheritanceSettingsPage } from './pages/settings/InheritanceSettingsPage';
import { Agreement36SettingsPage } from './pages/settings/Agreement36SettingsPage';
import { StaffingSettingsPage } from './pages/settings/StaffingSettingsPage';
import { ShiftPatternsSettingsPage } from './pages/settings/ShiftPatternsSettingsPage';
import { DefaultWorkPatternsSettingsPage } from './pages/settings/DefaultWorkPatternsSettingsPage';
import { StandingPatternTemplatesSettingsPage } from './pages/settings/StandingPatternTemplatesSettingsPage';
import { CompensationSettingsPage } from './pages/settings/CompensationSettingsPage';
import { VisibilityRulesSettingsPage } from './pages/settings/VisibilityRulesSettingsPage';
import { AttendanceSettingsPage } from './pages/settings/AttendanceSettingsPage';
import { WorkRecordApproversSettingsPage } from './pages/settings/WorkRecordApproversSettingsPage';
import { LabelsSettingsPage } from './pages/settings/LabelsSettingsPage';
import { FieldDefinitionsSettingsPage } from './pages/settings/FieldDefinitionsSettingsPage';
import { RequestTypesSettingsPage } from './pages/settings/RequestTypesSettingsPage';
import { RequestFieldVisibilitySettingsPage } from './pages/settings/RequestFieldVisibilitySettingsPage';
// v0.4 休暇管理 (TD-26) フロントエンド実装 (§6-1 L-3): 休暇種別マスタ + 法定値の確認 (D-279)
import { LeaveTypesSettingsPage } from './pages/settings/LeaveTypesSettingsPage';
import { CompetencyHierarchySettingsPage } from './pages/settings/CompetencyHierarchySettingsPage';
import { RequestsPage } from './pages/requests/RequestsPage';
// v0.4 章⑥ F-6 (§0-J-3): AIセットアップアシスタント + 割当ステージ設定
import { AiSetupAssistantPage } from './pages/settings/AiSetupAssistantPage';
import { AssignmentStagesSettingsPage } from './pages/settings/AssignmentStagesSettingsPage';
import { ReportViewsSettingsPage } from './pages/settings/ReportViewsSettingsPage';
import { DailyReportFieldsSettingsPage } from './pages/settings/DailyReportFieldsSettingsPage';
import { DailyReportNodePoliciesSettingsPage } from './pages/settings/DailyReportNodePoliciesSettingsPage';
import { DailyReportReconciliationRulesSettingsPage } from './pages/settings/DailyReportReconciliationRulesSettingsPage';
import { DailyReportVisibilityClassesSettingsPage } from './pages/settings/DailyReportVisibilityClassesSettingsPage';
import { RolesSettingsPage } from './pages/settings/RolesSettingsPage';
import { RolePermissionsEditPage } from './pages/settings/RolePermissionsEditPage';
import { AccountCategoriesSettingsPage } from './pages/settings/AccountCategoriesSettingsPage';
import { SuppliersLiteSettingsPage } from './pages/settings/SuppliersLiteSettingsPage';
import { CsvColumnMappingsSettingsPage } from './pages/settings/CsvColumnMappingsSettingsPage';
import { LiteCsvImportPage } from './pages/LiteCsvImportPage';
import { LiteManualEntryPage } from './pages/LiteManualEntryPage';
import { KpiThresholdsPage } from './pages/KpiThresholdsPage';
import { KpiTargetsPage } from './pages/KpiTargetsPage';
import { DenominationMastersPage } from './pages/DenominationMastersPage';
import { DailyReportsListPage } from './pages/daily-reports/DailyReportsListPage';
import { DailyReportOpenPage } from './pages/daily-reports/DailyReportOpenPage';
import { DailyReportDetailPage } from './pages/daily-reports/DailyReportDetailPage';
import { DailyReportAttachmentPage } from './pages/daily-reports/DailyReportAttachmentPage';
// v0.4 追加要件⑰: 社内文書ライブラリ (両 edition)
import DocumentsPage from './pages/DocumentsPage';
import DocumentDetailPage from './pages/DocumentDetailPage';
import { KpiTargetProgressPage } from './pages/KpiTargetProgressPage';
import { DailyReportSalesProgressPage } from './pages/DailyReportSalesProgressPage';
import { ImportsPage } from './pages/ImportsPage';
import { MenusPage } from './pages/MenusPage';
import { MenuCategoriesPage } from './pages/MenuCategoriesPage';
import { DeliveryServicesPage } from './pages/DeliveryServicesPage';
import { IngredientsPage } from './pages/IngredientsPage';
import { ManualEntryPage, LABOR_CONFIG, OPEX_CONFIG, DELIVERY_SALES_CONFIG } from './pages/ManualEntryPage';
import { SalesEntryPage } from './pages/SalesEntryPage';
import { DeliveryDetailsEntryPage } from './pages/DeliveryDetailsEntryPage';
import { VisitorCountsPage } from './pages/VisitorCountsPage';
import { AiOcrPage } from './pages/AiOcrPage';
import { AiOcrReviewPage } from './pages/AiOcrReviewPage';
import { AiMenuChatPage } from './pages/AiMenuChatPage';
import { AiMenuFavoritesPage } from './pages/AiMenuFavoritesPage';
import { AiMenuConstraintsPage } from './pages/AiMenuConstraintsPage';
import { SignatureProductProfilesPage } from './pages/SignatureProductProfilesPage';
import { ProfileEditPage } from './pages/ProfileEditPage';
import { ProfileBuilderChatPage } from './pages/ProfileBuilderChatPage';
import { AppLayout } from './components/AppLayout';
import { apiFetch, ApiClientError } from './lib/api';
import { useAuthStore, type CurrentUser } from './stores/auth';

export default function App() {
  const { user, setUser } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  // 初回起動時：ローカルトークンで /me を試行
  useEffect(() => {
    (async () => {
      if (!localStorage.getItem('access_token')) return;
      try {
        const me = await apiFetch<CurrentUser>('/auth/me');
        setUser(me);
      } catch (err) {
        if (err instanceof ApiClientError && err.status === 401) {
          navigate('/login', { replace: true });
        }
      }
    })();
  }, [setUser, navigate]);

  return (
    <Routes>
      <Route
        path="/login"
        element={
          user ? <Navigate to="/" replace /> : <LoginPage />
        }
      />
      {/* v1.0 招待リンク方式 (Chapter 8.8): 既存セッションの有無に関わらず常に表示する。
          LoginPageと違い、招待リンクは「別アカウントとしてセットアップする」ことが前提のフローのため
          user truthy → Navigate('/') にすると、既に他テナントにログイン済みのブラウザで開いた際に
          招待フロー自体が一切表示されずホーム(既存セッションのテナント)へ即リダイレクトされてしまう
          (実機で発覚、既存セッションを持つブラウザでの招待URL利用は現実的なシナリオ)。
          SetupPasswordPage側で既存セッションを明示的にクリアする */}
      <Route path="/setup-password" element={<SetupPasswordPage key="invite" mode="invite" />} />
      {/* v0.4 追加要件⑲ D-495: セルフリセットの引き換え。API は /auth/setup-password を共用し、
          振る舞いの差 (locked の解除) はサーバーが setup_tokens.purpose を見て分岐する。
          ⚠️ §8-95: 同一コンポーネントの再利用によるインスタンス持ち越しを避けるため key を付ける */}
      <Route path="/reset-password" element={<SetupPasswordPage key="reset" mode="reset" />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<HomePage />} />
        {/* v1.0 (Phase 3 Sprint 11): edition='lite'テナントはLite版データモデル専用の
            ダッシュボードを表示する (docs/design/v10-multi-tenant.md Chapter 4.7、routeレベルでの分岐、
            Full版DashboardOverviewPage.tsxは無変更のまま維持) */}
        <Route path="/dashboard" element={user?.edition === 'lite' ? <LiteDashboardPage /> : <DashboardOverviewPage />} />
        {/* 【2026-08-06 是正】Lite版はKPI推移・店舗比較ともLiteDashboardPage内に統合済み
            (Recharts trendチャート・比較テーブル、Sprint11実装済み)。個別ルートはFull版
            TrendsPage/StoreComparisonPageがsales_details等Full専用テーブルを参照するAPIを叩くため
            Liteテナントでは`no such table`で500になっていた (テナントBオンボード実機検証で発覚)。
            editionで分岐し、LiteはLiteDashboardPageへ誘導する。 */}
        <Route path="/dashboard/trends" element={user?.edition === 'lite' ? <Navigate to="/dashboard" replace /> : <TrendsPage />} />
        <Route path="/dashboard/comparison" element={user?.edition === 'lite' ? <Navigate to="/dashboard" replace /> : <StoreComparisonPage />} />
        <Route path="/dashboard/stores/:storeId" element={<StoreDashboardPage />} />
        <Route path="/dashboard/stores/:storeId/pl-tree" element={<PlTreePage />} />
        <Route path="/masters/stores" element={<NodesPage />} />
        {/* v0.4 章④ F-1 (§0-J-3): 最短ループの3画面。Full限定 (D-1、requiredFeature+fullOnlyでnavから
            ガード済みだがdirect URL遷移対策としてrouteの存在自体は残す。編集不可であればAPI側403が守る) */}
        <Route path="/shift/periods" element={<ShiftPeriodsPage />} />
        {/* v0.4 章④/⑥ F-2 (§0-J-3): 編成ボード (v0.4最難関画面) + 全社調整。board/coordination とも
            :id で period が一意に決まる画面のため /shift/periods 一覧からのみ遷移し、nav には追加しない
            (StoreDashboardPage の /dashboard/stores/:storeId と同型のドリルダウン先) */}
        <Route path="/shift/periods/:id/board" element={<ShiftBoardPage />} />
        <Route path="/shift/periods/:id/coordination" element={<ShiftCoordinationPage />} />
        <Route path="/shift/my" element={<ShiftMyPage />} />
        <Route path="/shift/preferences" element={<ShiftPreferencesPage />} />
        {/* v0.4 章④ F-3 (§0-J-3): シフト設定・マスタ (必要人員/パターン・営業時間/スキル・人材像・役職/イベント/恒常パターン) */}
        <Route path="/shift/standing-patterns" element={<ShiftStandingPatternsPage />} />
        {/* v0.4 追加要件⑮ 実装順序⑥ (旧 /shift/adjustments を改称): 勤務実績。Full 限定 (D-1) */}
        <Route path="/shift/records" element={<ShiftRecordsPage />} />
        {/* v0.4後半 月次実績一括入力。Full限定 (work_recordsがFull限定のため) */}
        <Route path="/shift/monthly-entry" element={<MonthlyAttendanceEntryPage />} />
        {/* 月次実績一括入力 第2フェーズ I-5 (§7-5): 承認一覧。Full限定 (work_recordsがFull限定のため) */}
        <Route path="/shift/work-record-approvals" element={<WorkRecordApprovalsPage />} />
        {/* 月次実績一括入力 第2フェーズ I-6b (§9-0/§9-1、D-1028): 管理部門向けの確認画面。Full限定 */}
        <Route path="/shift/attendance-review" element={<AttendanceReviewPage />} />
        {/* 月次実績一括入力 第2フェーズ I-6 (§8-5): 出力設定・実行。Full限定 (work_recordsがFull限定のため) */}
        <Route path="/shift/attendance-exports" element={<AttendanceExportsPage />} />
        <Route path="/shift/urgent" element={<ShiftUrgentPage />} />
        {/* v0.4 F-6 (§0-J-2 項目4、D-78): 印刷。/shift/periods 一覧またはボード画面からのみ遷移し
            nav アイコンからも直接開けるよう「シフト」グループに追加する (state 無しの直接URL遷移も
            成立するようクエリパラメータのみで完結させる) */}
        <Route path="/shift/print" element={<ShiftPrintPage />} />
        <Route path="/shift/report/daily" element={<ShiftReportDailyPage />} />
        <Route path="/shift/report/employees" element={<ShiftReportEmployeesPage />} />
        <Route path="/shift/report/compliance" element={<ShiftReportCompliancePage />} />
        {/* v0.4 章⑤ F-4 (§0-J-3): 年収の壁 本人確認画面。Full 限定 (D-1) */}
        <Route path="/me/income" element={<MyIncomePage />} />
        {/* TD-28 段階④ (D-5/D-10) + §14 手順8 (D-9): 休暇を含む全ドメインの申請はこの1画面に統合した。
            旧 /leave/me・/leave/manage は廃止。 */}
        <Route path="/requests" element={<RequestsPage />} />
        {/* TD-28 §18-3: 休暇の実績 (残数・年5日・有休管理簿)。申請ではないため /requests とは別画面。 */}
        <Route path="/leave/records" element={<LeaveRecordsPage />} />
        {/* ⚠️ 旧 URL からの誘導 (design-expert Major-6)。catch-all で無言でホームへ飛ばすと、
            ブックマーク・社内資料からの遷移で「消えた」ように見える。/imports に前例あり。 */}
        <Route path="/leave/me" element={<Navigate to="/leave/records" replace />} />
        <Route path="/leave/manage" element={<Navigate to="/leave/records" replace />} />
        {/* v0.4 休暇管理 (TD-26) 段階⑥: 長期休業 (産休・育休・介護休業) の期間計算・確定。
            ⚠️ これは「申請」ではなく記録・計算のドメインであり TD-28 の置換対象ではない (§18-0)。 */}
        <Route path="/leave/absences" element={<LeaveAbsencesPage />} />
        {/* v0.4 休暇管理 (TD-26) §6-1 L-2: 付与の実行・調整・取消。閲覧系は /leave/records に残す
            (この画面は leave_grant:manage:all_stores、あちらは本人・部下の残数閲覧で対象者が異なる) */}
        <Route path="/leave/grants" element={<LeaveGrantsPage />} />
        {/* v0.4 休暇管理 (TD-26) §6-1 L-5: 家族情報。⚠️ 要配慮個人情報を扱うため同意ゲート付き (D-80) */}
        <Route path="/me/family" element={<MyFamilyPage />} />
        {/* v0.4 使い勝手フィードバック⑤ (D-U7): 自分のスキル・人材像確認 (読み取り専用)。Full 限定 (D-1) */}
        <Route path="/me/skills" element={<MySkillsPage />} />
        {/* v0.5 人材育成ダッシュボード: チームロースター/認定の確定・インポート/人材像マトリクス/
            会社横断比較 のタブ統合画面。旧 /talent/skills・/talent/certifications・
            /talent/competency-matrix・/talent/development-plans を置き換え (単純リダイレクトは設けない、§3-1)。Full 限定 */}
        <Route path="/talent/dashboard" element={<TalentDashboardPage />} />
        {/* 人・組織機能 増分③ (SC-07、D-607): 配置制約の登録・一覧。増分⑤で SC-08 配置可否マトリクスタブを追加。Full 限定 (D-601) */}
        <Route path="/talent/placement-constraints" element={<PlacementConstraintsPage />} />
        {/* 人・組織機能 増分⑤ (SC-06、★月次会議の主画面): 充足状況ビュー (店舗×面)。Full 限定 (D-601) */}
        <Route path="/talent/coverage" element={<TalentCoveragePage />} />
        {/* 人・組織機能 増分⑤ (SC-09、UC-14★中核): 配置シミュレーション。Full 限定 (D-601) */}
        <Route path="/talent/simulation" element={<PlacementSimulationPage />} />
        {/* v0.4 章⑤ F-5 (§0-J-3): 承認受信箱。/settings/approvals (承認者ルール定義) とは別画面 */}
        <Route path="/approvals" element={<ApprovalsPage />} />
        {/* v0.5⑧ 経営会議PDCA (§7-7): P-2/P-4 は詳細 route (nav 非掲載) */}
        <Route path="/board-meetings" element={<BoardMeetingsListPage />} />
        <Route path="/board-meetings/:id" element={<BoardMeetingDetailPage />} />
        <Route path="/board-initiatives" element={<BoardInitiativesListPage />} />
        <Route path="/board-initiatives/:id" element={<BoardInitiativeDetailPage />} />
        <Route path="/masters/menus" element={<MenusPage />} />
        <Route path="/masters/menu-categories" element={<MenuCategoriesPage />} />
        <Route path="/masters/delivery-services" element={<DeliveryServicesPage />} />
        <Route path="/masters/ingredients" element={<IngredientsPage />} />
        <Route path="/masters/kpi-thresholds" element={<KpiThresholdsPage />} />
        {/* v0.4 追加要件⑭ */}
        <Route path="/masters/kpi-targets" element={<KpiTargetsPage />} />
        {/* v0.5① 日報機能 増分1 (D-837) */}
        <Route path="/masters/denominations" element={<DenominationMastersPage />} />
        {/* v0.5① 日報機能 増分1 (§14): P-1 (一覧) / P-2 (遷移専用) / P-3 (日報詳細・入力) / P-4 (添付・OCR確認)。
            P-4は独立ルート (§14-2、戻る操作で履歴が残るようモーダルにしない設計) */}
        <Route path="/daily-reports" element={<DailyReportsListPage />} />
        <Route path="/daily-reports/open" element={<DailyReportOpenPage />} />
        <Route path="/daily-reports/:id/attachments/:fieldDefinitionId" element={<DailyReportAttachmentPage />} />
        <Route path="/daily-reports/:id" element={<DailyReportDetailPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/documents/:documentId" element={<DocumentDetailPage />} />
        <Route path="/dashboard/targets" element={<KpiTargetProgressPage />} />
        <Route path="/dashboard/daily-report-sales-progress" element={<DailyReportSalesProgressPage />} />
        <Route path="/masters/skills" element={<SkillMastersPage />} />
        <Route path="/masters/store-events" element={<StoreEventsPage />} />
        <Route path="/masters/attendance-reason-codes" element={<AttendanceReasonCodesPage />} />
        <Route path="/masters/employee-grades" element={<EmployeeGradesPage />} />
        <Route path="/masters/working-time-contract-classes" element={<WorkingTimeContractClassesPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/employees" element={<EmployeesPage />} />
        {/* v0.4 章⑤ F-5 (§0-J-2): 実質新規の社員詳細ページ。/employees 一覧からのみ遷移し nav には
            追加しない (StoreDashboardPage の /dashboard/stores/:storeId と同型のドリルダウン先) */}
        <Route path="/employees/:id" element={<EmployeeDetailPage />} />
        <Route path="/roles" element={<RolesPage />} />
        <Route path="/audit-logs" element={<AuditLogsPage />} />
        <Route path="/ai-menu-usage" element={<AiMenuUsageRankingPage />} />
        <Route path="/publish-management" element={<PublishManagementPage />} />
        <Route path="/platform" element={<PlatformAdminPage />} />
        {/* key 必須: 同一コンポーネントのため React が再利用し、選択中の dataType が
            category を跨いで持ち越される (マスタ取込で menus 選択 → データ取込へ遷移すると
            プルダウンは「売上データ」表示のまま menus として送信され category guard に弾かれる) */}
        <Route path="/imports/data" element={<ImportsPage key="data" category="data" />} />
        <Route path="/imports/master" element={<ImportsPage key="master" category="master" />} />
        <Route path="/imports/lite" element={<LiteCsvImportPage />} />
        <Route path="/entry/lite" element={<LiteManualEntryPage />} />
        <Route path="/entry/labor" element={<ManualEntryPage config={LABOR_CONFIG} />} />
        <Route path="/entry/opex" element={<ManualEntryPage config={OPEX_CONFIG} />} />
        <Route path="/entry/delivery-sales" element={<ManualEntryPage config={DELIVERY_SALES_CONFIG} />} />
        <Route path="/entry/sales" element={<SalesEntryPage />} />
        <Route path="/entry/delivery-details" element={<DeliveryDetailsEntryPage />} />
        <Route path="/entry/visitor-counts" element={<VisitorCountsPage />} />
        <Route path="/ai-ocr" element={<AiOcrPage />} />
        <Route path="/ai-ocr/jobs/:jobId" element={<AiOcrReviewPage />} />
        <Route path="/ai/menu-chat" element={<AiMenuChatPage />} />
        <Route path="/ai/menu-favorites" element={<AiMenuFavoritesPage />} />
        <Route path="/ai/menu-constraints" element={<AiMenuConstraintsPage />} />
        <Route path="/ai/menu-profiles" element={<SignatureProductProfilesPage />} />
        <Route path="/ai/menu-profiles/builder/:sessionId" element={<ProfileBuilderChatPage />} />
        <Route path="/ai/menu-profiles/:profileId" element={<ProfileEditPage />} />
        {/* legacy: /imports は data カテゴリにリダイレクト (v0.3 で削除予定) */}
        <Route path="/imports" element={<Navigate to="/imports/data" replace />} />
        {/* v0.3.x レコード単位データ編集: /dashboard と同じく edition で画面を分岐する。
            ⚠️ nav の fullOnly を外しているため、data-browse.ts 側の requireEdition('full') が必須 */}
        <Route path="/data" element={user?.edition === 'lite' ? <LiteDataBrowsePage /> : <DataBrowsePage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/settings" element={<SettingsLayout />}>
          <Route index element={<Navigate to="/settings/general" replace />} />
          <Route path="general" element={<GeneralSettingsPage />} />
          <Route path="hierarchy" element={<HierarchyPage />} />
          <Route path="node-types" element={<NodeTypesPage />} />
          <Route path="roles" element={<RolesSettingsPage />} />
          <Route path="roles/:roleId/permissions" element={<RolePermissionsEditPage />} />
          <Route path="approvals" element={<ApprovalRuleBuilderPage />} />
          <Route path="aggregation" element={<AggregationSettingsPage />} />
          <Route path="visitor-count" element={<VisitorCountSettingsPage />} />
          {/* v0.5⑧ 経営会議PDCA (D-901、§7-5) */}
          <Route path="data-closing-deadlines" element={<DataClosingDeadlinesSettingsPage />} />
          <Route path="consumption-tax-rates" element={<ConsumptionTaxRatesSettingsPage />} />
          <Route path="account-categories" element={<AccountCategoriesSettingsPage />} />
          <Route path="suppliers-lite" element={<SuppliersLiteSettingsPage />} />
          <Route path="csv-column-mappings" element={<CsvColumnMappingsSettingsPage />} />
          <Route path="employee-categories" element={<EmployeeCategoriesSettingsPage />} />
          <Route path="employment-types" element={<EmploymentTypesSettingsPage />} />
          <Route path="features" element={<FeaturesSettingsPage />} />
          <Route path="locale" element={<PlaceholderSettingsPage title="地域/通貨" description="通貨・タイムゾーンの実運用UIはv1.0で対応予定です。" />} />
          <Route path="ai" element={<AiSettingsPage />} />
          <Route path="ai-instructions" element={<AiInstructionsSettingsPage />} />
          <Route path="notifications" element={<NotificationsSettingsPage />} />
          {/* v0.4 章② (D-57/D-58/D-60): 条件集合 + 階層継承設定 + 36協定。Full 限定 (D-1) */}
          <Route path="conditions" element={<ConditionsSettingsPage />} />
          <Route path="inheritance" element={<InheritanceSettingsPage />} />
          <Route path="agreement-36" element={<Agreement36SettingsPage />} />
          {/* v0.4 章④ F-3 (§0-J-3): 必要人員設定 + シフトパターン・営業時間。Full 限定 (D-1) */}
          <Route path="staffing" element={<StaffingSettingsPage />} />
          <Route path="shift-patterns" element={<ShiftPatternsSettingsPage />} />
          <Route path="default-work-patterns" element={<DefaultWorkPatternsSettingsPage />} />
          {/* v0.4 追加要件⑫ 増分③ (D-379): 恒常勤務パターンの名前付きマスタ。Full 限定 (§6e) */}
          <Route path="standing-pattern-templates" element={<StandingPatternTemplatesSettingsPage />} />
          {/* v0.4 章⑤ F-4 (§0-J-3): 給与単価 + 可視性ルール + 勤怠・法令設定。Full 限定 (D-1) */}
          <Route path="compensation" element={<CompensationSettingsPage />} />
          <Route path="visibility-rules" element={<VisibilityRulesSettingsPage />} />
          <Route path="attendance" element={<AttendanceSettingsPage />} />
          {/* v0.4 追加要件⑳-3 (D-593〜D-596): 勤務実績の承認者設定。Full 限定 (D-1) */}
          <Route path="work-record-approvers" element={<WorkRecordApproversSettingsPage />} />
          {/* v0.4 章③ (D-29/D-67/D-70): 用語辞書 + フィールド定義。両edition対応 (D-87) */}
          <Route path="labels" element={<LabelsSettingsPage />} />
          <Route path="field-definitions" element={<FieldDefinitionsSettingsPage />} />
          <Route path="request-types" element={<RequestTypesSettingsPage />} />
          <Route path="request-field-visibility" element={<RequestFieldVisibilitySettingsPage />} />
          {/* v0.4 休暇管理 (TD-26) §6-1 L-3: 休暇種別マスタ + 法定値の確認 (D-279)。Full 限定 (D-1) */}
          <Route path="leave-types" element={<LeaveTypesSettingsPage />} />
          {/* v0.5 ② タレントマネジメント階層構造化 (D-758/D-799): Full 限定 */}
          <Route path="competency-hierarchy" element={<CompetencyHierarchySettingsPage />} />
          {/* v0.4 章⑥ F-6 (§0-J-3): AIセットアップアシスタント + 割当ステージ設定。Full 限定 (D-1) */}
          <Route path="ai-setup" element={<AiSetupAssistantPage />} />
          <Route path="assignment-stages" element={<AssignmentStagesSettingsPage />} />
          {/* v0.4 追加要件⑪ 章⑦ (D-348): レポート設定 (表示項目・計算式)。Full 限定 */}
          <Route path="report-views" element={<ReportViewsSettingsPage />} />
          {/* v0.5① 日報機能 増分1 (§14 P-5〜P-7): SettingsLayout配下の3タブとして実装 (独立ページにしない) */}
          <Route path="daily-report/fields" element={<DailyReportFieldsSettingsPage />} />
          <Route path="daily-report/node-policies" element={<DailyReportNodePoliciesSettingsPage />} />
          <Route path="daily-report/reconciliation-rules" element={<DailyReportReconciliationRulesSettingsPage />} />
          <Route path="daily-report/visibility-classes" element={<DailyReportVisibilityClassesSettingsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to={location.pathname === '/login' ? '/login' : '/'} replace />} />
    </Routes>
  );
}

function ProtectedLayout() {
  const user = useAuthStore((s) => s.user);
  if (!user && !localStorage.getItem('access_token')) {
    return <Navigate to="/login" replace />;
  }
  return <AppLayout />;
}
